module.exports = __webpack_public_path__ + "img/MzKW.0ba033be.svg";